import React, { useContext } from "react";
import {ErrorBoundary} from 'react-error-boundary'
import axios from "../../utils/axios";
import PageError from '../../views/PageError';
import { customLogger } from "./CustomLogger";
import { BookingsFlowContext } from "../../contexts/BookingsFlowContext";


export default function AppErrorHandler(props){

    const apiPath = `${process.env.REACT_APP_API_URL}/logerror`;

    function ErrorFallback({error, resetErrorBoundary}) {
        return <PageError error={error} errorClick={resetErrorBoundary}  />
    }
     
    const bookingsFlowContext = useContext(BookingsFlowContext);


    function errorHandler(error,info){
        
        
        axios.post(apiPath,{
            error:error.message,
            info,
            bookingsFlowContext
        },{
            timeout: 30000,
            withCredentials:true
        }).catch(err => {
            customLogger(err);
        });
      }



      return (
        <ErrorBoundary
            FallbackComponent={ErrorFallback}
            onError={errorHandler}
            onReset={() => {
                // reset the state of your app so the error doesn't happen again
            }}
            >
            {props.children}
        </ErrorBoundary>
    );


}